/**
 * Anonymous-user recent-advisors localStorage helpers (HORO-10326).
 *
 * Logged-in users get `recentAdvisorAliases` from the backend (computed
 * from their chat history); anon users have no chat history we can
 * aggregate against, so we mirror the same shape into localStorage and
 * the sidebar reads from whichever source matches the auth state.
 *
 * Shape: `string[]` — distinct advisor aliases, most-recent first, cap 6.
 */
import { STORAGE_KEY_RECENT_ADVISORS } from '../../../const';

const MAX_RECENT = 6;

export const readRecentAdvisorAliases = () => {
    if (typeof window === 'undefined') return [];
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY_RECENT_ADVISORS);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed.filter((a) => typeof a === 'string' && a.length > 0).slice(0, MAX_RECENT);
    } catch {
        return [];
    }
};

export const pushRecentAdvisorAlias = (alias) => {
    if (!alias || typeof window === 'undefined') return;
    try {
        const current = readRecentAdvisorAliases();
        // Move-to-front + dedupe — the tapped advisor jumps to position 0
        // even if they were already in the list. Cap at MAX_RECENT so the
        // list never grows past what the sidebar can render.
        const next = [alias, ...current.filter((a) => a !== alias)].slice(0, MAX_RECENT);
        window.localStorage.setItem(STORAGE_KEY_RECENT_ADVISORS, JSON.stringify(next));
    } catch {
        // localStorage may throw in sandboxed iframes / private modes;
        // a missing recent list just means the sidebar shows defaults.
    }
};
